import React, { useEffect, useState, createElement } from 'react';
import { X, Download, FileDown, ExternalLink } from 'lucide-react';
declare global {
  interface Window {
    fbq: any;
  }
}
export function LloydPage() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  useEffect(() => {
    // Scroll to top when page loads
    window.scrollTo(0, 0);
    (function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js', null, null, null);
    window.fbq('init', '754551913878347');
    window.fbq('track', 'PageView');
    // Load Wistia scripts
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    const embedScript = document.createElement('script');
    embedScript.src = 'https://fast.wistia.com/embed/g1yujvw3vj.js';
    embedScript.async = true;
    embedScript.type = 'module';
    document.head.appendChild(playerScript);
    document.head.appendChild(embedScript);
    return () => {
      if (document.head.contains(playerScript)) {
        document.head.removeChild(playerScript);
      }
      if (document.head.contains(embedScript)) {
        document.head.removeChild(embedScript);
      }
    };
  }, []);
  return <div className="min-h-screen bg-black text-white font-sans" data-id="element-1948">
      {/* Meta Pixel Noscript */}
      <noscript data-id="element-1949">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=754551913878347&ev=PageView&noscript=1" alt="" data-id="element-1950" />
      </noscript>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-10 md:py-16" data-id="element-1951">
        {/* Header Section */}
        <div className="text-center mb-6 md:mb-10 space-y-5" data-id="element-1952">
          {/* Title */}
          <h1 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-black leading-tight tracking-tight" data-id="element-1953">
            Crea tu producto digital en minutos,{' '}
            <span className="neon-sweep" data-id="element-1954">sin salir de tu pantalla</span>
          </h1>

          {/* Subtitle */}
          <p className="text-base md:text-lg text-gray-100 max-w-4xl mx-auto leading-relaxed font-serif-elegant font-light" data-id="element-1955">
            Mira cómo construyo un producto digital desde cero, en tiempo real,
            con HeyLloyd como mi asistente sobre cualquier aplicación. Sin
            cursos eternos, sin configuraciones complicadas: solo ves, copias y
            lanzas.
          </p>
        </div>

        {/* Video Section */}
        <div className="mb-8 md:mb-12" data-id="element-1956">
          <div className="relative max-w-4xl mx-auto" data-id="element-1957">
            {/* Green glow effect */}
            <div className="absolute -inset-2 bg-gradient-to-r from-green-500 via-green-400 to-green-500 opacity-75 blur-2xl" data-id="element-1958"></div>

            <div className="relative aspect-video bg-gray-900 border border-green-500/50 overflow-hidden shadow-2xl" data-id="element-1959">
              <style data-id="element-1960">
                {`
                  wistia-player[media-id='g1yujvw3vj']:not(:defined) { 
                    background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/g1yujvw3vj/swatch'); 
                    display: block; 
                    filter: blur(5px); 
                    padding-top: 56.25%; 
                  }
                `}
              </style>
              <wistia-player media-id="g1yujvw3vj" aspect="1.7777777777777777" data-id="element-1961"></wistia-player>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="max-w-2xl mx-auto text-center space-y-5 mb-10 md:mb-14" data-id="element-1962">
          <a href="https://app.heylloyd.io/share/lloyd/2b44866d-5ed" target="_blank" rel="noopener noreferrer" className="group relative block w-full bg-gradient-to-b from-[#06b6d4] to-[#0891b2] hover:from-[#0891b2] hover:to-[#0e7490] text-white font-bold text-lg md:text-xl rounded-xl py-5 px-8 shadow-lg hover:shadow-[#06b6d4]/20 transition-all duration-300 transform hover:scale-[1.02]" data-id="element-1963">
            <span className="flex items-center justify-center gap-3" data-id="element-1964">
              <Download className="w-6 h-6" data-id="element-1965" />
              Descarga mi LLOYD PERSONALIZADO GRATIS
            </span>
          </a>

          {/* Urgency Text */}
          <p className="text-yellow-400 font-semibold text-sm md:text-base" data-id="element-1966">
            Oferta por tiempo limitado
          </p>

          {/* Support Text */}
          <p className="text-base md:text-lg text-gray-100 max-w-4xl mx-auto leading-relaxed font-serif-elegant font-light" data-id="element-1967">
            Convierte tu pantalla en un estudio de creación: idea, diseño,
            contenido y lanzamiento, todo guiado por mi Lloyd personalizado para
            que puedas replicarlo paso a paso.
          </p>

          {/* Demo Resources */}
          <div className="pt-4 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1968">
            <a href="https://drive.google.com/file/d/1RkyQQDL3XROBUWwY-NAVJiQpm7NQ2zdj/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gray-800 hover:bg-gray-700 text-white font-medium text-sm md:text-base rounded-lg py-3 px-6 border border-gray-700 hover:border-green-500/50 transition-all duration-300" data-id="element-1969">
              <FileDown className="w-5 h-5" data-id="element-1970" />
              Descargar Producto Demo
            </a>
            <a href="https://project-wise-swamp-350.magicpatterns.app" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gray-800 hover:bg-gray-700 text-white font-medium text-sm md:text-base rounded-lg py-3 px-6 border border-gray-700 hover:border-green-500/50 transition-all duration-300" data-id="element-1971">
              <ExternalLink className="w-5 h-5" data-id="element-1972" />
              Ver Website del Demo
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="w-full relative z-10 bg-black border-t border-gray-800 mt-14" data-id="element-1973">
        <div className="max-w-5xl mx-auto px-4 md:px-6 py-4 md:py-6" data-id="element-1974">
          {/* Legal Disclaimer */}
          <div className="text-gray-300 text-[10px] leading-tight space-y-2 text-left" data-id="element-1975">
            <p data-id="element-1976">
              48 HRS AI CASH MACHINE y todo el equipo asociado no asume
              responsabilidad por los resultados, ingresos o éxito que puedas
              obtener, ni garantiza resultados específicos. El éxito depende en
              parte del tiempo que dediques y de tu implementación de las guías,
              estrategias y soporte proporcionados. Todo el contenido,
              entrenamientos, artículos y material educativo tiene fines
              formativos únicamente y no debe interpretarse como asesoría
              financiera, legal o de inversión.
            </p>

            <p data-id="element-1977">
              Aunque nuestros servicios, sistemas y productos están diseñados
              para ayudar a nuestros clientes a crear y lanzar productos
              digitales con IA, no ofrecemos garantías (explícitas o implícitas)
              sobre resultados, ventas o ingresos derivados del uso de las
              ideas, herramientas o estrategias presentadas.
            </p>

            <p data-id="element-1978">
              Los testimonios compartidos corresponden a experiencias reales de
              usuarios, pero no deben considerarse como resultados típicos, ya
              que cada persona obtiene resultados diferentes según su situación
              y las acciones que decida tomar.
            </p>

            <p data-id="element-1979">
              Cualquier cifra interna, ejemplo o caso de estudio mostrado tiene
              fines ilustrativos y no garantiza que tú obtendrás los mismos
              resultados.
            </p>

            <p data-id="element-1980">
              Este sitio no forma parte de Google, Google Inc., Facebook/Meta o
              Meta Inc.
            </p>

            <p data-id="element-1981">
              Además, este sitio no está avalado, patrocinado ni aprobado por
              Google ni Meta de ninguna manera.
            </p>
          </div>

          {/* Copyright */}
          <div className="text-center mt-4 pt-3 border-t border-gray-800" data-id="element-1982">
            <p className="text-gray-300 text-[10px] mb-1" data-id="element-1983">
              &copy; 2025 48 Hrs AI Cash Machine. Todos los derechos reservados.
            </p>
            <p className="text-gray-200 text-[10px] mb-1" data-id="element-1984">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-[#06b6d4] hover:text-[#0891b2] transition-colors" data-id="element-1985">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex items-center justify-center gap-4 text-[10px]" data-id="element-1986">
              <button onClick={() => setShowTerms(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-1987">
                Términos
              </button>
              <span className="text-gray-400" data-id="element-1988">|</span>
              <button onClick={() => setShowPrivacy(true)} className="text-gray-200 hover:text-white transition-colors underline" data-id="element-1989">
                Privacidad
              </button>
            </div>
          </div>
        </div>
      </footer>

      {/* Terms Modal */}
      {showTerms && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowTerms(false)} data-id="element-1990">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-1991">
            <button onClick={() => setShowTerms(false)} className="absolute top-4 right-4 text-gray-300 hover:text-white transition-colors" data-id="element-1992">
              <X className="w-6 h-6" data-id="element-1993" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-1994">
              Términos y Condiciones
            </h2>
            <div className="text-gray-200 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-1995">
              <p data-id="element-1996">
                Al registrarte y participar en el 48 Hrs AI Cash Machine
                Masterclass, aceptas los siguientes términos y condiciones:
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-1997">
                1. Aceptación de Términos
              </h3>
              <p data-id="element-1998">
                Al acceder y utilizar este sitio web y registrarte para el
                evento, aceptas estar sujeto a estos términos y condiciones,
                todas las leyes y regulaciones aplicables.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-1999">
                2. Uso del Servicio
              </h3>
              <p data-id="element-2000">
                El contenido proporcionado en el masterclass es solo para fines
                educativos e informativos. No garantizamos resultados
                específicos de ingresos o éxito comercial.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2001">
                3. Propiedad Intelectual
              </h3>
              <p data-id="element-2002">
                Todo el contenido, materiales, y recursos proporcionados son
                propiedad de 48 Hrs AI Cash Machine y están protegidos por
                derechos de autor. No está permitida la reproducción o
                distribución sin autorización expresa.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2003">
                4. Limitación de Responsabilidad
              </h3>
              <p data-id="element-2004">
                48 Hrs AI Cash Machine no será responsable de ningún daño
                directo, indirecto, incidental o consecuente que resulte del uso
                o la imposibilidad de usar nuestros servicios.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2005">
                5. Modificaciones
              </h3>
              <p data-id="element-2006">
                Nos reservamos el derecho de modificar estos términos en
                cualquier momento. El uso continuado del servicio después de
                cambios constituye la aceptación de los nuevos términos.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2007">Contacto</h3>
              <p data-id="element-2008">
                Para preguntas sobre estos términos, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-2009">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}

      {/* Privacy Modal */}
      {showPrivacy && <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4" onClick={() => setShowPrivacy(false)} data-id="element-2010">
          <div className="bg-gray-900 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto p-6 md:p-8 relative" onClick={e => e.stopPropagation()} data-id="element-2011">
            <button onClick={() => setShowPrivacy(false)} className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" data-id="element-2012">
              <X className="w-6 h-6" data-id="element-2013" />
            </button>
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white" data-id="element-2014">
              Política de Privacidad
            </h2>
            <div className="text-gray-300 text-sm md:text-base space-y-4 leading-relaxed" data-id="element-2015">
              <p data-id="element-2016">
                En 48 Hrs AI Cash Machine, nos comprometemos a proteger tu
                privacidad. Esta política describe cómo recopilamos, usamos y
                protegemos tu información personal.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2017">
                1. Información que Recopilamos
              </h3>
              <p data-id="element-2018">
                Recopilamos información que nos proporcionas directamente,
                incluyendo:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2019">
                <li data-id="element-2020">Nombre y dirección de correo electrónico</li>
                <li data-id="element-2021">Información de registro del evento</li>
                <li data-id="element-2022">Comunicaciones que mantienes con nosotros</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2023">
                2. Uso de la Información
              </h3>
              <p data-id="element-2024">Utilizamos tu información para:</p>
              <ul className="list-disc list-inside space-y-2 ml-4" data-id="element-2025">
                <li data-id="element-2026">
                  Proporcionar acceso al masterclass y materiales relacionados
                </li>
                <li data-id="element-2027">Enviar comunicaciones sobre el evento</li>
                <li data-id="element-2028">Mejorar nuestros servicios y contenido</li>
                <li data-id="element-2029">Cumplir con obligaciones legales</li>
              </ul>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2030">
                3. Compartir Información
              </h3>
              <p data-id="element-2031">
                No vendemos ni compartimos tu información personal con terceros
                para fines de marketing. Podemos compartir información con
                proveedores de servicios que nos ayudan a operar nuestro
                negocio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2032">
                4. Seguridad de Datos
              </h3>
              <p data-id="element-2033">
                Implementamos medidas de seguridad técnicas y organizativas
                apropiadas para proteger tu información personal contra acceso
                no autorizado, alteración o destrucción.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2034">
                5. Tus Derechos
              </h3>
              <p data-id="element-2035">
                Tienes derecho a acceder, corregir o eliminar tu información
                personal. Para ejercer estos derechos, contáctanos en:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-2036">
                  support@truemarketer.com
                </a>
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2037">6. Cookies</h3>
              <p data-id="element-2038">
                Utilizamos cookies y tecnologías similares para mejorar tu
                experiencia en nuestro sitio web y analizar el uso del sitio.
              </p>
              <h3 className="text-lg font-bold text-white mt-6" data-id="element-2039">Contacto</h3>
              <p data-id="element-2040">
                Para preguntas sobre esta política de privacidad, contacta:{' '}
                <a href="mailto:support@truemarketer.com" className="text-green-500 hover:text-green-400" data-id="element-2041">
                  support@truemarketer.com
                </a>
              </p>
            </div>
          </div>
        </div>}
    </div>;
}